import { Typography, Box } from 'vendor/material';
import { ProgressClock, Lock, HelpCircle } from 'mdi-material-ui';
import { makeStyles } from 'vendor/material';
import { Tooltip } from '@tackle-io/platform-ui';
import { fontWeightMedium } from '../../utils/fontWeightConstants';
import React from 'react';

const useStyles = () =>
  makeStyles((theme) => ({
    icon: {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL100,
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    helpIcon: {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.PURPLE300,
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontWeight: fontWeightMedium,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(24),
      color: theme.palette.NEUTRAL600,
    },
    subTitle: {
      color: theme.palette.NEUTRAL300,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      marginRight: theme.spacing(0.5),
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    permissions: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(22),
      color: theme.palette.NEUTRAL300,
      marginRight: theme.spacing(1),
      display: 'flex',
      alignContent: 'center',
      '& > b': {
        marginRight: theme.spacing(1.5),
      },
    },
    subTitleSection: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      marginRight: theme.spacing(1),
      display: 'flex',
      alignContent: 'center',
    },
  }))();

interface Props {
  permissions?: string;
  timeToComplete?: string;
  subTitle?: string | React.ReactNode;
  helpText?: string;
  docsToolTip?: React.ReactNode;
}

const PermissionTimeSubTitle: React.FC<Props> = ({
  permissions,
  timeToComplete,
  subTitle,
  helpText,
  docsToolTip,
}) => {
  const classes = useStyles();
  const lockIcon = (
    <span className={classes.icon}>
      <Lock fontSize={'inherit'} />
    </span>
  );
  const progressClockIcon = (
    <span className={classes.icon}>
      <ProgressClock fontSize={'inherit'} />
    </span>
  );
  const helpCircleIcon = (
    <span className={classes.helpIcon}>
      <HelpCircle fontSize={'inherit'} />
    </span>
  );

  return (
    <Box>
      <div className={classes.permissions}>
        {permissions && (
          <>
            {lockIcon}Permissions required:&nbsp;<b>{permissions}</b>
          </>
        )}
        {timeToComplete && (
          <>
            {progressClockIcon}Time to complete:&nbsp;<b>{timeToComplete}</b>
          </>
        )}
      </div>
      {subTitle && (
        <div className={classes.subTitleSection}>
          <Typography className={classes.subTitle}>{subTitle}</Typography>
          {docsToolTip}
          {helpText && !docsToolTip && (
            <Tooltip content={<p>{helpText}</p>}>{helpCircleIcon}</Tooltip>
          )}
        </div>
      )}
    </Box>
  );
};

export default PermissionTimeSubTitle;
